import { Nullable } from '@store/types'
import { FlowState, Font, FontType, MarkType, State, TaskResult, TaskType } from '@const/consts'

export interface ISharedState {
  envelope: IEnvelope
  signatureMarks: Nullable<ISignatureMark>
  signatureMarksNextTask: Nullable<ISignatureMark>
  signatures: ISignatures
  signaturesNextTask: ISignatures
  taskResult: Nullable<TaskResult>
  isTriedSubmit: boolean
  currentMarkKey: Nullable<string>
  highlightedMarkKey: Nullable<string>
  markKeysArray: string[]
  pointerSwitch: Nullable<boolean>
  lastPhone: Nullable<string>
  lastPhoneNextTask: Nullable<string>
  isCamOpened: boolean
  selfieImg: Nullable<string>
  selfieImgNextTask: Nullable<string>
  selfieGuidNextTask: Nullable<string>
  selfieGuid: Nullable<string>
  scale: number
  taskCounter: Nullable<number>, /* null - one signer, number - task order 0 or 1 */
}

export interface ISignatureMark {
  [key: string]: boolean
}

export interface IEnvelope {
  allowedActions: string[]
  oguid: string
  files: IFile[]
  boxTaskOguid: string
  flow: IFlow[]
  flowState: FlowState
  flowStartDateTime: string,
  isNextStageSigningRequired: boolean,
  sender: ISender
  subject: string
  accessAuthorizedTo: IAccessAuthorizedTo
}

export interface ISender {
  boxEmail: string
  boxOguid: string
  user: IUser
}

export interface IAccessAuthorizedTo {
  user: Nullable<IUserWithSign>;
  type: IUserAccessType;
  expirationDateTime: Nullable<string>;
  isUserActive: Nullable<boolean>;
}

export interface IUserWithSign extends IUser {
  electronicSignatureImage: Nullable<string>;
}

export enum IUserAccessType {
  ANONYMOUS = "ANONYMOUS",
  TOKEN = "TOKEN",
  GUEST_TOKEN = "GUEST_TOKEN",
  EMAIL = "EMAIL"
}

export interface IUser {
  oguid: string
  position: Nullable<string>
  email: string
  fullName: string
}

export interface IFile {
  index: number
  filename: string
  signedProperties: Nullable<object>
}

export interface IFlow {
  state: State
  tasks: ITask[]
}

export interface ITask {
  completedDateTime: string
  recipient: IRecipient
  oguid: string
  type: TaskType
  state: State
  result: Nullable<TaskResult>
}

export interface IRecipient {
  email: string
  prepositionedMarks: IPrepositionMarkWithKey[]
  declaredSigner: IDeclaredSigner
  isRequireSms: boolean
  isRequireSelfie: boolean
  isHostMode: boolean
}

export interface IDeclaredSigner {
  fullName: string
  initials?: Nullable<string>
  position?: Nullable<string>
  phone?: Nullable<number>
}

export interface IPrepositionMarkWithKey extends IPrepositionMark {
  key: string
}

export interface IPrepositionMark {
  fileIndex: number
  pageNumber: number
  topLeftX: number
  topLeftY: number
  height: Nullable<number>
  width: Nullable<number>
  type: MarkType
  valueList: Nullable<string[]>
  value: Nullable<string | boolean>
  fontSize: Nullable<number>
  fontType: Nullable<FontType>
  font: Nullable<Font>
  color: Nullable<string>
  scale: Nullable<number>
  tooltip: Nullable<string>
  checkboxValue?: boolean
  isReadOnly: boolean
  isRequired: boolean
  /** лейбл к полю типа CUSTOM (обязательный для этого типа) */
  label?: Nullable<string>
}

export interface IPrepositionMarks {
  [key: string]: IPrepositionMark
}

export interface ISignatures {
  uploadSignature: Nullable<string>
  drawSignatureFull: Nullable<string>
  drawSignatureTrim: Nullable<string>
  newSignature: Nullable<string>
}

export interface IFileDownload {
  sharedLinkOguid: string
  fileIndex: string
  fileName: string
  docType: string
}

export interface IPhoneConfirmInit {
  phone: number
}

export interface IPhoneConfirmData {
  sharedLinkOguid: string
  data: IPhoneConfirmInit
}

export interface IPhoneConfirmResponseData {
  tranId: string
  expired: number
}

export interface ISelfieShelfData {
  sharedLinkOguid: string
  data: FormData
}

export interface ISignatureMarksData {
  signatureMarks: ISignatureMark
  isNextTask: boolean
}

export interface IValueFromModeData {
  value: Nullable<string>
  isNextTask?: boolean
}

export interface IDeclineTask {
  sharedLinkOguid: string
  comment: Nullable<string>
}
